import { PersonalDataState } from './index';
import { ActionTree } from 'vuex';
// @ts-ignore
import { IState } from "../index";
import Room from "../interfaces/room";
import ContactRoom from "../interfaces/contactRoom";
import ContactPerson from "../interfaces/contactPerson";
import AvailableRoom from "../interfaces/availableRoom";
import { AxiosError, AxiosResponse } from "axios";
import { postResponse } from "@store/services/fetchCheckoutData";

export default {
    initPersonalData({ commit, state, rootState }) {
        if (rootState.checkout.isOnlyNonBinding) {
            return;
        }

        const roomsState: ContactRoom[] = state.rooms;

        const rooms: ContactRoom[] = [];
        const persons: ContactPerson[] = [];

        rootState.checkout.rooms.rooms.forEach((room: Room) => {
            const roomEntry: AvailableRoom = rootState.checkout.rooms.availableRooms.find((item: AvailableRoom) => item.id === room.id);
            if (room.amount === 0 || !roomEntry) {
                return;
            }

            for (let y = 0; y < room.amount; y++) {
                for (let i = 0; i < roomEntry.minPersons; i++) {
                    persons.push(
                        {
                            salutation: '',
                            firstname: '',
                            lastname: '',
                            roomId: room.id,
                            roomNumber: y,
                            birthDate: '',
                            isDriver: false,
                            nationality: '',
                            iso2: ''
                        }
                    )
                }

                rooms.push({
                    id: room.id,
                    roomNumber: y,
                    title: roomEntry.title + ' ' + (y + 1),
                    amount: roomEntry.minPersons,
                    mainDriver: null
                });
            }
        });

        commit('setDefaultPersons', persons);

        if (JSON.stringify(rooms) !== JSON.stringify(roomsState)) {
            commit('setUseContactInfo', null);
            commit('setContactRooms', rooms);
            commit('setContactPersons', persons);
        }
    },
    async initDriverCount({ commit, dispatch, rootState, rootGetters }) {
        await postResponse(
            rootState.checkout.apiEndpoint,
            'GetDriverCount',
            rootState.checkout.apiToken,
            {
                'tripId': rootState.checkout.checkoutSettings.trip.id,
                'appointmentId': rootState.checkout.checkoutSummary.appointmentId,
                'upgradeIds': rootGetters['checkout/getCarUpgradeIds'],
                'fare' : rootState.checkout.checkoutSummary.fare,
                'sessionId': rootState.checkout.checkoutSummary.sessionId
            },
            rootState.checkout.checkoutSettings.locale
        )
            .then((response: AxiosResponse) => {
                commit('setDriverCount', response.data);
            })
            .catch((e: AxiosError) => {
                dispatch('openErrorOverlay');

                const responseStatus = e.response ? e.response.status : 'none';
                const message = `Error in initDriverCount | Error code: 1642576781729 | HTTP status: ${responseStatus} | ${e.message}`;

                throw Error(message);
            });
    }
} as ActionTree<PersonalDataState, IState>
